import * as React from "react";
import {IBackOfficeTheme} from "../theme";
import {defaultTheme} from "../default/index";

import {fullWhite, fullBlack} from 'material-ui/styles/colors';
import {MetropolisLogo} from "./components/MetropolisLogo";
import {MetropolisShortLogo} from "./components/MetropolisShortLogo";
import {MetropolisNonLoggedBG} from "./components/NonLoggedBG/MetropolisNonLoggedBG";
import {BasicPhone} from "../components/BasicPhone";

const primaryColor = '#2a2a2a';
const accentColor = '#2ea99c';
const accent2Color ='#2a4f4b';
const backgroundColor = '#000';
const activeBackgroundColor = '#2A2A2A';
const alternateTextColor = fullWhite;
const labelColor = fullWhite;

export const metropolisTheme: IBackOfficeTheme = {
  ...defaultTheme,
  primaryColor: primaryColor,
  accentColor: accentColor,
  accent2Color: accent2Color,
  backgroundColor: backgroundColor,
  alternateTextColor: alternateTextColor,
  labelColor: labelColor,
  logo: {
    component: MetropolisLogo,
    style: {
      width: 314,
      height: 59
    }
  },
  nonLogged: {
    bgComponent: MetropolisNonLoggedBG,
    phoneComponent: React.createElement(BasicPhone),
    phoneScreenUrl: <string>require('./assets/menu.png')
  },
  navBar: {
    logo: MetropolisShortLogo,
    backgroundColor: fullBlack,
    activeBackgroundColor: activeBackgroundColor,
    color: fullWhite,
    iconColor: accentColor
  }
};



// WEBPACK FOOTER //
// ./src/themes/metropolis/index.ts